module.exports = __webpack_public_path__ + "img/pakiet_1.2f71f200.svg";